import { Container, log } from './Container.js';
let REGISTRY = new WeakMap();
export function testSupport_clearRegisty() {
    REGISTRY = new WeakMap();
}
export const HAS_FACTS_CLASS = 'has-facts-container';
const HAS_FACTS_SELECTOR = `.${HAS_FACTS_CLASS}`;
/**
 * Search the DOM upwards for an existing container that is closest to the given element
 * @param el the element for which a container should be found
 * @returns the closest container or null if none could be found
 */
export function closestContainer(el) {
    var _a;
    return containerOn((_a = el.closest(HAS_FACTS_SELECTOR)) !== null && _a !== void 0 ? _a : el.ownerDocument.documentElement);
}
/**
 * Retrieves an existing container for the given element or creates a new one if it has the `has-facts-container` class.
 *
 * Returned container inherits from the closest ancestor element that has a container.
 * If no such ancestor is found, it is created on the document.
 * @param el the element for which to create the container
 * @returns a new or existing facts container
 * @throws an exception if the given element is missing the `has-facts-container` class
 */
export function containerOn(el) {
    var _a, _b;
    if (REGISTRY.has(el)) {
        const container = REGISTRY.get(el);
        return container;
    }
    if (!el.parentElement) {
        const rootContainer = new Container();
        REGISTRY.set(el, rootContainer);
        return rootContainer;
    }
    if (!el.classList.contains(HAS_FACTS_CLASS)) {
        log.error('Could not create facts container on', el, 'as it’s missing the', HAS_FACTS_CLASS, 'class');
        throw new Error(`Could not create facts container on ${el.tagName} element, it is missing ${HAS_FACTS_CLASS} class`);
    }
    const parent = (_b = (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.closest(HAS_FACTS_SELECTOR)) !== null && _b !== void 0 ? _b : el.ownerDocument.documentElement;
    const container = containerOn(parent).derive();
    REGISTRY.set(el, container);
    el.classList.add(HAS_FACTS_CLASS);
    return container;
}
/**
 * Retrieves an existing container for the given element or creates a new one.
 *
 * Returned container inherits from the closest ancestor element that has a container.
 * If no such ancestor is found, it is created on the document.
 * @deprecated using this may yield in unexpected nesting when called on elements missing the `has-facts-container` class. Use {@link closestContainer} or {@link containerOn} instead, which handle these cases explicitly.
 * @param el the element for which to create the container
 * @returns a new or existing facts container, never null
 */
export function containerFor(el) {
    log.warn('Deprecated use of', containerFor.name);
    el.classList.add(HAS_FACTS_CLASS);
    return containerOn(el);
}
